/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {FormattedMessage} from 'react-intl';
import {Grid, Button} from '@scuf/common';
import SimilarFaultCard from "./SimilarFaultCard";

class SimilarFaultCards extends React.Component {
    constructor() {
        super();
        this.state = {
            numberOfCards: 3,
        }
    }

    render() {
        const faultCards = this.props.faults.map(f => <Grid.Column key={f.id} width={4} sWidth={12}><SimilarFaultCard
            fault={f} numberOfAllocatedSymptoms={this.props.numberOfAllocatedSymptoms}/></Grid.Column>);
        const limitedCards = faultCards.slice(0, this.state.numberOfCards)
        return (
            <div>
                <Grid>
                    <Grid.Row>
                        {faultCards.length === 0 && !this.props.loading ?
                            <Grid.Column size={12}><FormattedMessage id="faults.results.empty"/></Grid.Column>
                            :
                            limitedCards
                        }
                    </Grid.Row>
                    <Grid.Row>
                        {(faultCards.length === 0 && !this.props.loading) || this.state.numberOfCards >= faultCards.length?
                            null
                            :
                            <Grid.Column size={12}>
                                <div className="more-button">
                                    <Button type="link" onClick={() => this.setState({numberOfCards: this.state.numberOfCards + 6})}>{<FormattedMessage id={"fault.showMore"}/>}</Button>
                                </div>
                            </Grid.Column>
                        }
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
}


export default SimilarFaultCards